import React from "react";
import "../styles/contactFloat.css";
import { Link } from "react-router-dom";
import contactFloatImg from "../images/contactFloatImg.jpg";

const contactFloat = () => {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return (
    <>
      <section className="contact-float-wrap">
        <div className="contact-float">
          <div className="contact-float-content">
            <h2>Want to find out more?</h2>
            <p>
              We have 25 years experience helping customers like you exceed
              their objectives. Get in touch today.
            </p>
            <Link to="/contact" onClick={scrollToTop}>
              <button>Contact Us</button>
            </Link>
          </div>
          <div className="contact-float-img">
            <img src={contactFloatImg} alt="Full Team" />
          </div>
        </div>
      </section>
    </>
  );
};

export default contactFloat;
